module.exports = "/images/v_filter_xlt_1.jpg?ba10d5768505b29686acca1990786ffd";